import { Account } from '@ally/data-types-afg-accounts'
import {
  Session,
  SubNavDropdownSchema,
  SubNavLinkSchema,
} from '@ally/federated-types'
import { getRoles } from '../../utils'

export const scoreInsights = {
  type: 'link',
  content: 'Score Insights',
  url: '/credit-score',
  key: 'scoreInsights',
  metadata: {
    withAllyTM: 'Financial Health - Score Insights',
  },
} as SubNavLinkSchema

export const creditCardFicoScore = {
  type: 'link',
  content: 'Credit Card: FICO® Score',
  url: '/sso/credit-card/Account/FICOSCORE',
  key: 'creditCardFicoScore',
  metadata: {
    withAllyTM: 'Credit Scores - Credit FICO',
  },
} as SubNavLinkSchema

export const getAutoFicoScore = (id: string): SubNavLinkSchema => {
  return {
    type: 'link',
    content: 'Auto: FICO® Score',
    url: `/sso/auto/accounts/${id}`,
    key: 'autoFicoScore',
    metadata: {
      withAllyTM: 'Credit Scores - Auto FICO',
    },
  } as SubNavLinkSchema
}

export const debtPlanLink = {
  type: 'link',
  content: 'Manage Debt',
  url: '/debt-plan',
  key: 'debtPlan',
  metadata: {
    withAllyTM: 'Financial Health - Manage Debt',
  },
} as SubNavLinkSchema

export const creditScore = {
  type: 'link',
  content: 'Credit Score',
  url: '/credit-score',
  key: 'creditScore',
  metadata: {
    withAllyTM: 'Financial Health - Credit Score',
  },
} as SubNavLinkSchema

interface FinancialHealthMenuProps {
  session: Session
  isDebtPlanEnabled: boolean
  isAutoUser: boolean
  allAutoAccounts: Account[]
  financialHealthEnabled: boolean
}

export const getFinancialHealthMenu = ({
  session,
  isDebtPlanEnabled,
  isAutoUser,
  allAutoAccounts,
  financialHealthEnabled,
}: FinancialHealthMenuProps): SubNavDropdownSchema[] => {
  if (!financialHealthEnabled) return []
  const { bank, creditcard, auto } = getRoles(session)
  const financialHealthLinks = [] as SubNavLinkSchema[]
  const showMultiLobLinks =
    [bank, auto, creditcard].filter(role => role).length > 1
  const isBankOnly = !showMultiLobLinks && bank

  if (isBankOnly) {
    financialHealthLinks.push(creditScore)
  } else if (showMultiLobLinks) {
    if (bank) {
      financialHealthLinks.push(scoreInsights)
    }
    if (creditcard) {
      financialHealthLinks.push(creditCardFicoScore)
    }
    if (isAutoUser) {
      const aggrementId = allAutoAccounts[0]?.id
      if (aggrementId) {
        financialHealthLinks.push(getAutoFicoScore(aggrementId))
      }
    }
  }
  if (isDebtPlanEnabled) {
    financialHealthLinks.push(debtPlanLink)
  }

  if (financialHealthLinks.length) {
    return [
      {
        type: 'menu',
        triggerContent: 'Financial Health',
        items: financialHealthLinks,
        key: 'financialHealth',
      },
    ] as SubNavDropdownSchema[]
  }
  return []
}
